module.exports = __webpack_public_path__ + "static/media/marta.bee8bca4.jpg";